import { authInterceptor } from './auth-interceptor'
import { sentryInterceptor } from './sentry-interceptor'
import { traceInterceptor } from './telemetry-interceptor'

export const interceptors = [authInterceptor, sentryInterceptor, traceInterceptor]
